import { render, staticRenderFns } from "./editor_textChapter.vue?vue&type=template&id=22b50f10&scoped=true"
import script from "./editor_textChapter.vue?vue&type=script&lang=js"
export * from "./editor_textChapter.vue?vue&type=script&lang=js"
import style0 from "./editor_textChapter.vue?vue&type=style&index=0&id=22b50f10&prod&lang=scss&scoped=true"
import style1 from "./editor_textChapter.vue?vue&type=style&index=1&id=22b50f10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b50f10",
  null
  
)

export default component.exports